import Action, {GET, POST_FORM,POST} from "../common/Action";

export const saveTokenAction = new Action('SAVE_TOKEN');
export const signOutAction = new Action('SIGN_OUT');
export const signInAction = new Action('SIGN_IN', POST_FORM, 'Users/TokenInv', 'SIGN_IN_FAILURE');

export const saveToken = (tokenInfo, isNew) => saveTokenAction.setResult({data: {...tokenInfo, isNew}});

export const setSignOut = (isSignOut) => signOutAction.setResult({data: isSignOut});

export const signIn = (username, password) => {
    let params = new URLSearchParams();
    params.append('grant_type', 'password');
    params.append('username', username);
    params.append('password', password);
    params.append('client_id', 'android');
    return signInAction.callApi(params);
};

